import React from 'react';
import cn from 'classnames';
import { Spring, animated } from 'react-spring';

import styles from './style.css';

const Home = () => (
  <div className={styles.home}>
    <div className={styles.home__text}>
      <Spring native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div style={style} className={styles.home__text__main}>
            Building apps that are out of this world
          </animated.div>
        )}
      </Spring>
      <Spring native delay={1200} from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div style={style} className={styles.home__text__secondary}>
            Work in Progress is an agency with over a decade of experience
            designing and building award winning iOS and Android Apps.
          </animated.div>
        )}
      </Spring>
    </div>
    <div className={styles.hero}>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.svg
            className={cn(styles.hero__element, styles.hero__gradient)}
            width="1305"
            height="1307"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
          >
            <defs>
              <radialGradient
                fx="50%"
                fy="50%"
                gradientTransform="matrix(1 0 0 .99847 0 0)"
                id="a"
              >
                <stop stopColor="#27222E" offset="0%" />
                <stop stopColor="#5B41CD" offset="52.04%" />
                <stop stopColor="#5267EE" offset="76.02%" />
                <stop stopColor="#3988EA" offset="100%" />
              </radialGradient>
            </defs>
            <ellipse
              cx="1104.703"
              cy="653.93"
              rx="652"
              ry="653"
              transform="translate(-452)"
              fill="url(#a)"
              fillRule="nonzero"
            />
          </animated.svg>
        )}
      </Spring>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div
            style={style}
            className={cn(styles.hero__element, styles.hero__backdrop)}
          />
        )}
      </Spring>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div
            style={style}
            className={cn(styles.hero__element, styles.hero__stars)}
          />
        )}
      </Spring>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div
            style={style}
            className={cn(styles.hero__element, styles.hero__planets)}
          />
        )}
      </Spring>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div
            style={style}
            className={cn(styles.hero__element, styles.hero__character)}
          />
        )}
      </Spring>
      <Spring delay={300} native from={{ opacity: 0 }} to={{ opacity: 1 }}>
        {style => (
          <animated.div
            style={style}
            className={cn(styles.hero__element, styles.hero__earth)}
          />
        )}
      </Spring>
    </div>
  </div>
);

export default Home;
